module.exports = __webpack_public_path__ + "img/logo_site.71f164bf.webp";